import { sfwUrl, studioHost } from "./env";
import { routes } from "@/common/utils/routes";
import { loadRedditAppVisit } from "@/common/utils/storage";
import { getDeviceType, deviceTypeEnum, getWindowWidth } from "@/common/utils/device";
import { IGeolocation } from "@/common/api/services/types";
import { metricsBus } from "../buses";

const COMMON_ALLOWED_PAGES = [
  "/auth/signin",
  "/authorize",
  "/logout",
  "/ifr/",
  "/user/verify",
  "/experiments",
];

const LITE_ONLY_COUNTRIES = ["GB"];
const AGE_VERIFICATION_COUNTRIES = ["AU"];
const AGE_VERIFICATION_STATES = ["kentucky", "oklahoma", "south carolina", "georgia", "louisiana", "texas", "indiana", "missouri", "kansas", "florida", "west virginia", "iowa"];

export const isAgeVerificationLocation = (location: IGeolocation | null): boolean => {
  return AGE_VERIFICATION_COUNTRIES.includes(location?.country || "")
    || AGE_VERIFICATION_STATES.includes(location?.state || "");
};

export const isLiteOnlyLocation = (location: IGeolocation | null): boolean => {
  return LITE_ONLY_COUNTRIES.includes(location?.country || "");
};

export const isPageAllowed = (pathname: string, location: IGeolocation | null): boolean => {
  const isMobile = getDeviceType(getWindowWidth()) === deviceTypeEnum.PHONE;
  const isAgeVerificationSignUpPage = pathname.startsWith(routes.userSignUp())
    && isAgeVerificationLocation(location);

  if (loadRedditAppVisit() && isMobile && (isAgeVerificationLocation(location) || isLiteOnlyLocation(location))) {
    return true; // Reddit app users from countries with mandatory age verification can access all pages
  }

  if (COMMON_ALLOWED_PAGES.some((page) => pathname.startsWith(page))) {
    return true; // Common pages e.g. guidelines are always allowed
  }

  if (isLiteOnlyLocation(location)) {
    return false;
  }

  if (isAgeVerificationSignUpPage) {
    return true;
  }

  if (location === null) {
    return false; // Geolocation not determined yet, block by default
  }

  const statePage = location.state ? routes.geoBlockedPage(location.state) : "";

  if (statePage && pathname.startsWith(statePage)) {
    return true; // User is on the specific geo-blocked page for their state
  }

  return !location.blocked;
};

export const getStudioUrl = (): string => `https://${studioHost}`;

export const getAlternatePage = (
  pathname: string,
  location: IGeolocation | null,
  isCreator = false,
): string | null => {
  if (!isPageAllowed(pathname, location)) {
    if (isLiteOnlyLocation(location)) {
      return isCreator ? getStudioUrl() : sfwUrl;
    }

    if (isAgeVerificationLocation(location)) {
      metricsBus.emit("ageGateRedirected", location ?? {});

      return sfwUrl;
    }

    if (location?.state) {
      return routes.geoBlockedPage(location.state);
    }
  }

  return null;
};
